var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    stroke: "#000",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .spinner_V8m1 {\n      transform-origin: center;\n      animation: spinner_zKoa 2s linear infinite;\n      stroke: white;\n    }\n\n    .spinner_V8m1 circle {\n      stroke-linecap: round;\n      animation: spinner_YpZS 1.5s ease-in-out infinite;\n\n\n    }\n\n    @keyframes spinner_zKoa {\n      100% {\n        transform: rotate(360deg)\n      }\n    }\n\n    @keyframes spinner_YpZS {\n      0% {\n        stroke-dasharray: 0 150;\n        stroke-dashoffset: 0\n      }\n\n      47.5% {\n        stroke-dasharray: 42 150;\n        stroke-dashoffset: -16\n      }\n\n      95%,\n      100% {\n        stroke-dasharray: 42 150;\n        stroke-dashoffset: -59\n      }\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "spinner_V8m1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    fill: "none",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBlob);
export default __webpack_public_path__ + "static/media/loading-blob.baa3b81ad33d49c48d0f9274769b440a.svg";
export { ForwardRef as ReactComponent };